$(function() {

    /*if($(".league-page-header").length > 0) {
        const el = document.querySelector(".league-page-header")
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("league-page-header-stuck", e.intersectionRatio < 1),
            {threshold: [1]}
        );

        observer.observe(el);
    }*/

    $("#general_teamstats li").each(function(e) {
        if (e != 0)
            $(this).hide();
    });

    var myModal = document.getElementById('filterModal');
    var myInput = document.getElementById('filter_toggle');

    if(myModal != undefined) {
        myModal.addEventListener('shown.bs.modal', function () {
            myInput.focus();
        })
    }

    $(document).on("click", "#show_all_highlights", function(e){
        e.preventDefault();
        $(".hidden-highlight").removeClass('hidden-highlight');
        $(this).hide();
        return false;
    });
    $(document).on("click", "#ts_next", function(){
        if ($("#general_teamstats li:visible").next().length != 0)
            $("#general_teamstats li:visible").next().show().prev().hide();
        else {
            $("#general_teamstats li:visible").hide();
            $("#general_teamstats li:first").show();
        }
        return false;
    });

    $(document).on("click", "#ts_prev", function(){
        if ($("#general_teamstats li:visible").prev().length != 0)
            $("#general_teamstats li:visible").prev().show().next().hide();
        else {
            $("#general_teamstats li:visible").hide();
            $("#general_teamstats li:last").show();
        }
        return false;
    });

   if($("#rotate-device").length){
       setTimeout(function(){ $("#rotate-device").fadeOut(); }, 6000);
   }
   $("#rotate-device").click(function(){
      $(this).fadeOut();
   });


   if($("#league_standings_live").length){
       refresh_live_standings();
       setInterval(refresh_live_standings, 60000); //60000
   }

   if($("#league_standings_live_match").length){
       setInterval(refresh_live_standings_match, 60000);
   }

   if($("#wc_standings_live_match").length){
       setInterval(refresh_live_wc_standings_match, 60000);
   }

    $(document).on("change", "#league-season-select", function(){
        var active_season = $("#active-season-id").val();
        var season_id = $("#league-season-select").find(":selected").data("season-id");
        var league_id = $("#league-season-select").find(":selected").data("league-id");
        var season_val = $("#league-season-select").val();

        $("#league-season-wrapper").css("opacity", "0.5");
        $.get(
            ajaxUrl+"/ajax/getLeagueBySeason.php",
            {
                season_id : season_id,
                league_id : league_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    if(season_id != active_season){
                        $("li.nav-item[data-tab='matcher']").hide();
                        $("li.nav-item[data-tab='odds']").hide();
                        $("li.nav-item[data-tab='tv']").hide();
                    } else {
                        $("li.nav-item[data-tab='matcher']").show();
                        $("li.nav-item[data-tab='odds']").show();
                        $("li.nav-item[data-tab='tv']").show();
                    }
                    // Save the selected season in ls for fetching if a user attempts to go back from eg matchpage
                    Cookies.set('league_select_id', league_id, { expires: 0.01, path: '/' });
                    Cookies.set('league_season_select_id', season_id, { expires: 0.01, path: '/' });
                    Cookies.set('league_season_select_val', season_val, { expires: 0.01, path: '/' });

                    $( '[data-toggle="tab"][href="#standing"]' ).trigger( 'click' );
                    $("#league-season-wrapper").replaceWith(result.data);
                    $("#league-season-wrapper").css("opacity", "1");
                    refresh_live_standings();
                    if(result.hide_matches_tabs == 1){
                        $('li a[href="#matches"]').parent().hide();

                    } else {
                        $('li a[href="#matches"]').parent().show();
                    }
                    if(result.hide_results_tabs == 1){
                        $('li a[href="#results"]').parent().hide();
                    } else {
                        $('li a[href="#results"]').parent().show();
                    }
                    var liCount = $('.league_menu li:visible').length;
                    if(liCount == 3){
                        $('.league_menu li:visible').css('flex', '0 0 33.33%');
                    }
                    if(liCount == 4){
                        $('.league_menu li:visible').css('flex', '0 0 25%');
                    }
                    if(liCount == 5){
                        $('.league_menu li:visible').css('flex', '0 0 20%');
                    }
                    if($("#rotate-device").length){
                        setTimeout(function(){ $("#rotate-device").fadeOut(); }, 2000);
                    }
                    $("#rotate-device").click(function(){
                        $(this).fadeOut();
                    });
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                }
            }
        );
    });

   if($("#league-template").length > 0){
       var cookieLeague = Cookies.get('league_select_id');

       if(cookieLeague != undefined){
           var cookieSeason = Cookies.get('league_season_select_id');
           if(cookieLeague == $("#league-template").data('league-id')){
               if(cookieSeason != $("#league-template").data('season-id')){
                   var cookieSeasonVal = Cookies.get('league_season_select_val');
                   $("#league-season-select").val(cookieSeasonVal).trigger('change');
               }
           }
       }
   }



   $(document).on('click', '#show_more_fixtures', function(e){
       e.preventDefault();
       $('.fixture-hidden').removeClass('fixture-hidden');
       $(this).remove();
       return false;
   });
   $(document).on('click', '#show_more_results', function(e){
       e.preventDefault();
       $('.result-hidden').removeClass('result-hidden');
       $(this).remove();
       return false;
   });

    $(document).on("change", "#cup-season-select", function(){
        var active_season = $("#active-season-id").val();
        var season_id = $("#cup-season-select").find(":selected").data("season-id");
        var league_id = $("#cup-season-select").find(":selected").data("league-id");
        $("#league-season-wrapper").css("opacity", "0.5");
        $.get(
            ajaxUrl+"/ajax/getCupBySeason.php",
            {
                season_id : season_id,
                league_id : league_id
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    if(season_id != active_season){
                        $("li.nav-item[data-tab='matcher']").hide();
                        $("li.nav-item[data-tab='odds']").hide();
                        $("li.nav-item[data-tab='tv']").hide();
                    } else {
                        $("li.nav-item[data-tab='matcher']").show();
                        $("li.nav-item[data-tab='odds']").show();
                        $("li.nav-item[data-tab='tv']").show();
                    }
                    $( '[data-toggle="tab"][href="#standing"]' ).trigger( 'click' );
                    $("#league-season-wrapper").replaceWith(result.data);
                    $("#league-season-wrapper").css("opacity", "1");
                    if(result.hide_matches_tabs == 1){
                        $('li a[href="#matches"]').parent().hide();

                    } else {
                        $('li a[href="#matches"]').parent().show();
                    }
                    if(result.hide_results_tabs == 1){
                        $('li a[href="#results"]').parent().hide();
                    } else {
                        $('li a[href="#results"]').parent().show();
                    }
                    var liCount = $('.league_menu li:visible').length;
                    if(liCount == 3){
                        $('.league_menu li:visible').css('flex', '0 0 33.33%');
                    }
                    if(liCount == 4){
                        $('.league_menu li:visible').css('flex', '0 0 25%');
                    }
                    if(liCount == 5){
                        $('.league_menu li:visible').css('flex', '0 0 20%');
                    }
                    if($("#rotate-device").length){
                        setTimeout(function(){ $("#rotate-device").fadeOut(); }, 2000);
                    }
                    $("#rotate-device").click(function(){
                        $(this).fadeOut();
                    });
                }
            }
        );
    });

	$(document).on("click", ".euro-qual-trigger", function(){
	    $(".euro-qual-trigger").removeClass("euro-qual-trigger");
		$("#qualifyers").css("opacity", "0.5");
		$.get(
            ajaxUrl+"/ajax/getEuroQual.php",
            {
                league_id : 1325
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#qualifyers").html(result.data);
                    $("#qualifyers").css("opacity", "1");
                }
            }
		);
	});

	$(".bet_select").change(function(){
		var target = $(this).find(':selected').data('event');
		$(".bet-tabs .tab-pane").removeClass("active");
		$("#"+target).addClass("active");
		return false;
	});

   if($("#league-template").length > 0){
       if($("#league-template").data("condensed") == 1) {
           var season_id = $("#league-template").data("season-id");
           var league_id = $("#league-template").data("league-id");
           $.get(
               ajaxUrl + "/ajax/getCondensedLeagueBySeason.php",
               {
                   season_id: season_id,
                   league_id: league_id
               },
               function (data) {
                   var result = $.parseJSON(data);
                   if (result.success == true) {
                       $("#league-season-wrapper").append(result.data);
                       $("#rotate-device").click(function(){
                           $(this).fadeOut();
                       });
                   }
               }
           );
       }
   }
});

function refresh_live_standings(){
    var season_id = $("#league_standings_live").data("season-id");
    var league_id = $("#league_standings_live").data("league-id");
    if(season_id && league_id) {
        $("#league-season-wrapper").css("opacity", "0.5");
        $.get(
            ajaxUrl + "/ajax/getLiveLeagueStanding.php",
            {
                league_id: league_id,
                season_id: season_id
            },
            function (data) {
                var result = $.parseJSON(data);
                if (result.success == true) {
                    $("#league-stading-live > tbody").replaceWith(result.html);
                }
            }
        );
        $("#league-season-wrapper").css("opacity", "1");
    }
}

function refresh_live_standings_match(){
    var season_id = $("#league_standings_live_match").data("season-id");
    var league_id = $("#league_standings_live_match").data("league-id");
    var home_team_id = $("#league_standings_live_match").data("home-team-id");
    var away_team_id = $("#league_standings_live_match").data("away-team-id");
    var group_id = $("#league_standings_live_match").data("group-id");
    $("#league-season-wrapper").css("opacity", "0.5");
    $.get(
        ajaxUrl+"/ajax/getLiveMatchStanding.php",
        {
            league_id : league_id,
            season_id : season_id,
            home_team_id : home_team_id,
            away_team_id : away_team_id,
            group_id : group_id
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $(".leaguestanding > tbody").replaceWith(result.html);
            }
        }
    );
    $("#league-season-wrapper").css("opacity", "1");
}
function refresh_live_wc_standings_match(){
    var group_id = $("#wc_standings_live_match").data("group-id");
    var season_id = $("#wc_standings_live_match").data("season-id");
    var home_team_id = $("#wc_standings_live_match").data("home-team-id");
    var away_team_id = $("#wc_standings_live_match").data("away-team-id");
    $("#league-season-wrapper").css("opacity", "0.5");
    $.get(
        ajaxUrl+"/ajax/getLiveWcMatchStanding.php",
        {
            group_id : group_id,
            season_id : season_id,
            home_team_id : home_team_id,
            away_team_id : away_team_id
        },
        function(data){
            var result = $.parseJSON(data);
            if(result.success == true){
                $(".world-cup-standing > tbody").replaceWith(result.html);
            }
        }
    );
    $("#league-season-wrapper").css("opacity", "1");
}